var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9985V16.9985C0 16.9985 5 14.9985 10 14.9985C15 14.9985 20 16.9985 20 16.9985V18.9985H0ZM9.3 6.09847C8.1 2.19847 2 3.09847 2 3.09847C2 3.09847 2.2 10.8985 7.9 9.69847C7.5 6.79847 6 5.99847 6 5.99847C8.8 5.99847 9 9.39847 9 9.39847V13.9985H11V9.79847C11 9.79847 11 5.89847 14 4.89847C14 4.89847 12 7.89847 12 9.89847C19 10.5985 19 0.998466 19 0.998466C19 0.998466 10.1 -0.00153351 9.3 6.09847Z",
    fill: "#113E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon2);
export default __webpack_public_path__ + "static/media/aboutIcon2.c3528dc0c9533232c8e543d86188ca12.svg";
export { ForwardRef as ReactComponent };